// extracted by mini-css-extract-plugin
export default {"addToCartControl":"YY-z","giftCard":"ZY-z","btnContainer":"_Y-z","cartButton":"aZ-z","disabled":"bZ-z"};